import React from "react";
import "./SmallTitle.scss";

export default function SmallTitle({
    children,
    className = '',
    ...rest
}) {
    return (
        <h3 className={`small-title ${className}`} {...rest}>
            {children}
        </h3>
    );
}
